// @flow
import getSessionId from "./getSessionId";

export const isAuthenticated = (): boolean => Boolean(getSessionId());

export default isAuthenticated;